import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';
import Logo from './../../icons/normal.svg';
function UserCard({
    id,
    name,
    profilePicture,
    onRemoveUser,
    onCancelInvite,
    showDeleteButton,
    userId,
    email,
    status,
}) {
    return (
        <li className="col-lg-2 col-md-4 col-sm-6 user-card">
            <div className="row justify-content-center">
                <div className="col-10 p-2 single-user-card">
                    <div className="row justify-content-end pr-2">
                        {showDeleteButton &&
                        ((id && id !== userId) || status === 'SENT') ? (
                            <img
                                onClick={() =>
                                    id
                                        ? onRemoveUser(id)
                                        : onCancelInvite(email)
                                }
                                src={Logo}
                                className="crosslogo"
                            />
                        ) : (
                            <div
                                style={{
                                    height: `16px`,
                                }}
                            ></div>
                        )}
                    </div>
                    <div className="row justify-content-center">
                        {/* <img className="image" src={profilePicture} width={'50%'} height={'100%'} /> */}
                        <div
                            style={{
                                backgroundImage: `url(${profilePicture ||
                                    'https://media.dev.litterati.org/thumbnail-153033'})`,
                            }}
                            className="user-image"
                        ></div>
                    </div>

                    <div className="row justify-content-center text-center user-label">
                        {name || email}
                    </div>
                    {status === 'SENT' ? (
                        <div className="row justify-content-center text-center invite-sent">
                            Invite sent
                        </div>
                    ) : (
                        ''
                    )}
                </div>
            </div>
        </li>
    );
}

UserCard.propTypes = {
    // user details to be displayed in a list item
    id: PropTypes.number,
    name: PropTypes.string,
    profilePicture: PropTypes.string,
    onRemoveUser: PropTypes.func,
    onCancelInvite: PropTypes.func,
    showDeleteButton: PropTypes.bool,
    userId: PropTypes.number,
    isLoading: PropTypes.bool,
    email: PropTypes.string,
    status: PropTypes.string,
};

UserCard.defaultProps = {
    id: null,
    name: null,
    profilePicture: null,
    showDeleteButton: false,
    userId: null,
    isLoading: false,
    email: null,
    status: null,
};

export default UserCard;
